import { PageSkeleton } from '@app/components'
import { createBrowserRouter } from 'react-router'
import { adminRoutes } from './routes/admin'
import { portalRoutes } from './routes/portal'
import { publicRoutes } from './routes/public'
import { AdminShell } from './shells/AdminShell'
import { PortalShell } from './shells/PortalShell'
import { PublicShell } from './shells/PublicShell'
import { RootErrorBoundary } from './shells/RootErrorBoundary'

/** Shown while a lazily loaded route module is still downloading on first paint. */
function HydrateFallback() {
  return (
    <div className="container" style={{ paddingTop: 'var(--bp-space-6)' }}>
      <PageSkeleton />
    </div>
  )
}

export const router = createBrowserRouter([
  {
    path: '/',
    Component: PublicShell,
    ErrorBoundary: RootErrorBoundary,
    HydrateFallback,
    children: publicRoutes,
  },
  {
    path: '/sign-in',
    lazy: () => import('./routes/public/SignIn').then((m) => ({ Component: m.SignIn })),
    ErrorBoundary: RootErrorBoundary,
    HydrateFallback,
  },
  {
    // Where emailed sign-in links land (the button, not the visit, signs in).
    path: '/sign-in/email',
    lazy: () => import('./routes/public/SignInEmail').then((m) => ({ Component: m.SignInEmail })),
    ErrorBoundary: RootErrorBoundary,
    HydrateFallback,
  },
  {
    path: '/portal',
    Component: PortalShell,
    ErrorBoundary: RootErrorBoundary,
    HydrateFallback,
    children: portalRoutes,
  },
  {
    path: '/admin',
    Component: AdminShell,
    ErrorBoundary: RootErrorBoundary,
    HydrateFallback,
    children: adminRoutes,
  },
])
